import { createSlice } from "@reduxjs/toolkit";
import hospitalDetailApi from "../../../rtk-apis/hospital/hospitalDetails";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const hospitalDetailsSlice = createSlice({
  name: "hospitalDetailsSlice",
  initialState,
  reducers: {
    clearHospitalDetails: (state: any) => {
      state.status = '';
      state.result = {};
      state.msg = '';
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hospitalDetailApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(hospitalDetailApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(hospitalDetailApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default hospitalDetailsSlice.reducer;
export const { clearHospitalDetails } = hospitalDetailsSlice.actions;
